import * as yup from 'yup';

const plainText = {
  base: yup.string().typeError('errorMessages.string')
};
plainText.required = plainText.base.required('errorMessages.required');
plainText.optional = plainText.base;

export default plainText;
